import * as types from './mutation-types'

export default {

    [types.SET_LICENSES] (state, licenses) {
        if(Array.isArray(licenses)){
            state.licenses = licenses
        }else {
            state.licenses = Object.values(licenses)
        }
    },

    [types.ADD_LICENSE] (state, license) {
        state.licenses.push(license)
    },

    [types.SET_LICENSE] (state, license) {
        state.license = license
    },

    [types.SET_LOADING] (state, loading) {
        state.loading = loading
    },

    [types.CLEAR_LICENSE] (state) {
        state.license = null
        state.licenses = []
    },

    [types.SET_LICENSE_LIST] (state, list) {
        state.licenseList = Array.isArray(list) ? list : Object.values(list)
    },

    [types.SET_LIST_LOADING] (state, loading) {
        state.listLoading = loading
    },

    [types.SET_API_CONFIG] (state, config) {
        state.apiConfig = config
    }
}
